import Vue from 'vue';
import Currency from 'currency.js';

Vue.use(Currency);

Vue.filter('currency', val => Currency(val, { formatWithSymbol: true, precision: 0 }).format());
Vue.filter('cryptocurrency', val => Currency(val, { formatWithSymbol: false, precision: 8 }).format());
